import { useAiContextValue } from "@common/components/AiChat/hooks";
import AppContext, { type AppContextProps } from "@common/contexts/App";
import { type AppTheme, type WithChildren } from "@common/declarations";
import { identityPromise } from "@common/lib/misc";
import React from "react";

type Props = WithChildren & {
  theme: AppTheme;
};
const AppContextProvider = (props: Props) => {
  const ai = useAiContextValue();

  const value = React.useMemo(
    (): AppContextProps => ({
      ai,
      context: "next",
      theme: props.theme,
      toggleTheme: identityPromise
    }),
    [ai, props.theme]
  );

  return <AppContext.Provider value={value}>{props.children}</AppContext.Provider>;
};
export default AppContextProvider;
